import {observer} from "mobx-react";
import {Brand} from "../../../models/Brand";
import piginiLogo from "../../../assets/img/pigin_logo_without_text.jpeg";
import excelsiorLogo from "../../../assets/img/excelsior_logo_without_text.png";
import React from "react";
import {useStore} from "../../../stores/Store";
import ButtonFilter from "./ButtonFilter";
import { GiAccordion } from "react-icons/gi";

export default observer(function BrandFilter(){
    const {LanguageStore, AccordionStore} = useStore();
    const { currentLanguageMessages} = LanguageStore;
    const { setFilteredBrand, filteredBrand, accordions, mode  } = AccordionStore

    const getButtonObjects = (): any[] => {
        const objects: any[] = [
            {value: Brand.Pigini, img: piginiLogo, imgAlt: 'Pigini Logo', imgBorderRadius: '20%'},
            {value: Brand.Excelsior, img: excelsiorLogo, imgAlt: 'Excelsior Logo', imgBorderRadius: '50%'},
        ];
        const rentalMode = mode === 'rent'
        if(accordions.filter(a => a.rental === rentalMode && a.brand === Brand.Other).length > 0)
            objects.push({value: Brand.Other, Icon: GiAccordion, imgAlt: 'Other Logo', imgBorderRadius: '0'})
        return objects;
    }



    return (
        <ButtonFilter
            title={currentLanguageMessages.AccordionsPage.Filter.brandTitle}
            filteredValue={filteredBrand}
            setFilteredValue={setFilteredBrand}
            buttonObjects={getButtonObjects()}
            attributeName='brand'
        />
    )
})